<template>
  <div class="tab-switcher">
    <v-tabs v-model="selectedTab" horizontal>
      <v-tab v-for="tab in tabs" :key="tab.id">
        {{ tab.label }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="selectedTab">
      <v-tab-item v-for="tab in tabs" :key="tab.id">
        <v-card flat>
          <v-card-text>
            <slot :name="tab.id"></slot>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
export default {
  name: 'TabSwitcher',
  props: {
    tabs: {
      type: Array,
      required: true
    },
    value: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      selectedTab: this.value
    };
  },
  watch: {
    selectedTab(val) {
      this.$emit('input', val);
    },
    value(val) {
      this.selectedTab = val;
    }
  }
};
</script>

<style lang="scss" scoped>
.tab-switcher {
  width: 100%;
}
</style>